import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zChargingStationModelSchemaDom, zChargingStationModelSchemaCreateDom, zChargingStationModelSearchViewSchema, } from "@/types/chargingStationModel/chargingStationModel.domain";
import { zChargingStationModelSchemaDto, zChargingStationModelSchemaCreateDto, } from "@/types/chargingStationModel/chargingStationModel.dto";
const baseMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zChargingStationModelSchemaDom.parse(dto),
    domainToDto: (domain) => zChargingStationModelSchemaDto.parse(domain),
    dtoToCreateDto: (domain) => zChargingStationModelSchemaCreateDto.parse(domain),
    dtoToCreateDom: (dto) => zChargingStationModelSchemaCreateDom.parse(dto),
});
export const ChargingStationModelMapper = {
    ...baseMapper,
    toSearchData: (dto) => {
        return zChargingStationModelSearchViewSchema.parse(dto);
    },
};
